// extracted by mini-css-extract-plugin
module.exports = {"userPic":"styles_userPic__1EhpE","img":"styles_img__pQ7RU","uploader":"styles_uploader__1TGvF"};